export default __webpack_public_path__ + "images/5845406b00a5ba62c0bb92b3f65cdcf6.svg";